import { forwardRef } from 'react';
import styles from '../styles/Notes.module.css';
import ButtonOverride from '../components/buttonoverride';

const RHFButtonListSelect = forwardRef(({options = [],label,onChange,value,error,disabled,multiple = false},ref) => {

    const selectedValues = multiple && Array.isArray(value) ? value : [];

    const isSelected = (optionId) => {
        return multiple ? selectedValues.includes(optionId) : value === optionId;
    };

    const handleClick = (option) => {
        if(!multiple){
            onChange(option);
            return;
        }

        if(selectedValues.includes(option)){
            onChange(selectedValues.filter((selectedOption) => selectedOption !== option));
        }
        else{
            onChange([...selectedValues,option]);
        }
    };

    return(
        <div ref={ref} className={`${error ? styles.error : null}`}>
            <strong>{label}</strong>
            <div className={styles.filterDialogBody}>
            {
                options.map((option) => (
                    <ButtonOverride disabled={disabled} type='button' key={option.id} aria-pressed={isSelected(option.id)} className={`${styles.filterDialogSelectBtn} ${isSelected(option.id) ? styles.active : null}`} onClick={() => handleClick(option.id)}>
                        {option.name}
                    </ButtonOverride>
                ))
            }
            </div>
            {error && <small style={{ color: 'red' }}>{error.message}</small>}
        </div>
    )
});

export default RHFButtonListSelect;
